var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (backgroundColor, caption, compose, continueBtnText, doneText, hasCaption, hasNarration, hasPrompt, i18n, prompt, submitUp, url) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"block-v-lg content-fill text-center\">");
jade_mixins["image"](url, 'img content-ver'+ (compose ? ' img-compose' : ''));
buf.push("<div class=\"slide-loader content\"></div></div>");
if ( hasCaption)
{
buf.push("<div class=\"text-center\"><div" + (jade.attr("style", "background-color: " + (backgroundColor) + ";", true, false)) + " class=\"caption block-lg text-md\">");
if ( caption.title)
{
buf.push("<p><strong>" + (null == (jade_interp = caption.title) ? "" : jade_interp) + "</strong></p>");
}
if ( caption.content)
{
buf.push(null == (jade_interp = caption.content) ? "" : jade_interp);
}
buf.push("</div></div>");
}
buf.push("<div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"backgroundColor" in locals_for_with?locals_for_with.backgroundColor:typeof backgroundColor!=="undefined"?backgroundColor:undefined,"caption" in locals_for_with?locals_for_with.caption:typeof caption!=="undefined"?caption:undefined,"compose" in locals_for_with?locals_for_with.compose:typeof compose!=="undefined"?compose:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasCaption" in locals_for_with?locals_for_with.hasCaption:typeof hasCaption!=="undefined"?hasCaption:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"url" in locals_for_with?locals_for_with.url:typeof url!=="undefined"?url:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}